import $ from "jquery"
import "slick-carousel"

import FullPage from "./fullpage"
import Form from "./form"
import {
  PageName,
  ScreenName,
  mainScreenName,
  CommonOption,
} from "./constants"

import initAboutSlider from "./about-project-slider"
import { initControlsSlider } from "./events-gallery-slider"
import toggleLocales from "./toggle-locales"

import modalNavigation from "./modal-navigation"
import modalInfrastructure from "./modal-infrastructure"
import modalAbouSlider from "./modal-about-slider"
import modalEventsSlider from "./modal-events-gallery"
import modalFlats from "./modal-flats"
import modalForm from "./modal-form"
import modalVideo from "./modal-video"
import modalTrezini from "./modal-trezini"
import modalExclusives from "./modal-exclusives"

import { setGalleryToggler } from "./toggle-screen-pictures"
import initMap from "./map"

const classNames = {
  header: {
    HEADER_SHRINKED: `page-header--shrinked`,
    MENU_HIDDEN: `page-header__menu--hidden`,
  },
  footer: {
    FOOTER_EXPANDED: `page-footer--expanded`,
    PRESENTATION_MOVED: `page-footer__presentation--moved`,
    PRESENTATION_HIDDEN: `page-footer__presentation--hidden`,
    TOGGLE_SHOWN: `page-footer__toggle--shown`,
    FOOTER_ABOUT_SLIDER: `flats-types__toggles--footer--shown`,
    FOOTER_ABOUT_SLIDER_HIDDEN: `flats-types__toggles--footer--hidden`,
  },
  modal: {
    MODAL_SHOWN: `modal--shown`,
    NAV_ITEM_MOVED: `modal__navigation-item--moved`,
  },
  mobile: {
    SLIDER_TITLE_VISIBLE: `screen__title--visible`,
  },
  sidePanel: {
    SIDE_PANEL_HIDDEN: `side-panel--hidden`,
  },
}
const flatTypesAddresses = {
  [`loft`]: `/loft`,
  [`historical`]: `/art_residence`,
  [`whitebox`]: `/white_box`,
}
const windowWidth = window.innerWidth

//TODO: create basic class for all pages, set basic methods
export default class MainPage {
  constructor() {
    this.page = document.querySelector(`.page`)
    this.locales = this.page.querySelector(`.locales`)
    this.isMobile = windowWidth <= CommonOption.MOBILE_VERSION_WIDTH
    this.header = this.page.querySelector(`.page-header`)
    this.menu = this.header.querySelector(`.page-header__menu`)
    this.footer = this.page.querySelector(`.page-footer`)
    this.copyright = this.footer.querySelector(`.page-footer__copyright`)
    this.presentation = this.footer.querySelector(`.page-footer__presentation`)
    this.aboutSlider = this.footer.querySelector(
      `.flats-types__toggles--footer`
    )
    this.navigation = [...this.header.querySelectorAll(`.page-header__link`)]
    this.onPageRenderCallbacks = []
    this.onScreenChangeCallbacks = []
    this.locale = null
  }

  init(locale) {
    this.locale = locale
    if (this.isMobile) {
      this.initMobile()
    } else {
      this.initDesktop()
    }
    this.formatValues() //phone formatting
    this.initContacts()
    this.initFullPage()
    initAboutSlider(this.page)
    initControlsSlider(this.isMobile) //events controls
    this.initModals(locale)
    this.bind()
    initMap(this.isMobile, this.locale)
    toggleLocales()
    this.updateVideoSrc(this.locale)
  }

  getVimeoSrc(id) {
    return `https://player.vimeo.com/video/${id}?title=0&byline=0&portrait=0`
  }

  updateVideoSrc(locale) {
    let vimeoSrc = ""

    $(".about__slide .screen__video").click(() => {
      if (locale === "ru") {
        vimeoSrc = this.getVimeoSrc("1089991478")
      } else if (locale === "en") {
        vimeoSrc = this.getVimeoSrc("1089991478")
      } else if (locale === "cn") {
        vimeoSrc = this.getVimeoSrc("1089991478")
      }
      $(".modal-video iframe").attr("src", vimeoSrc)
    })

    $(".intro .screen__video, .js-modal-video").click(() => {
      if (locale === "ru") {
        vimeoSrc = this.getVimeoSrc("1090471034")
      } else if (locale === "en") {
        vimeoSrc = this.getVimeoSrc("1090471034")
      } else if (locale === "cn") {
        vimeoSrc = this.getVimeoSrc("1090471034")
      }
      $(".modal-video iframe").attr("src", vimeoSrc)
    })
  }

  initDesktop() {
    this.onPageRenderCallbacks.push(this.updatePanels)
    this.onScreenChangeCallbacks.push(this.updatePanels)
  }

  initMobile() {
    const iOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
    if (iOS) document.body.className += " iOS"

    this.initMobileSliders()
    const toggleMobileLocales = (index) => {
      const screen = ScreenName[index]

      this.updateLocales(screen)
      this.updateMobileFooter(screen)
    }

    this.onPageRenderCallbacks.push(toggleMobileLocales)
    this.onScreenChangeCallbacks.push(toggleMobileLocales)
  }

  //TODO: create separate module for sliders
  initMobileSliders() {
    const containers = [
      this.page.querySelector(`#infrastructure-main-slider`),
      this.page.querySelector(`#flats-main-slider`),
    ]
    const options = {
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      speed: 300,
      useCSS: false,
    }

    containers.forEach((container) => $(container).slick(options))
    containers.forEach((container) => {
      $(container).on(`afterChange`, () => {
        const sliderType = container.dataset.slider
        const activeSlide = container.querySelector(
          `.slick-active .screen-pictures__item`
        )
        const activeSlideType = activeSlide.dataset.id
        const wrap = container.closest(`.screen.${sliderType}`)

        this.toggleMobileDetailsLink(wrap, activeSlideType, sliderType)
        this.toggleMobileSliderTitles(wrap, activeSlideType, sliderType)
      })
    })
  }

  initContacts() {
    const contactsForm = new Form(`contacts-form`, `contacts`)

    contactsForm.init()
  }

  initFullPage() {
    const fullPageParallax = new FullPage(
      {},
      this.onPageRenderCallbacks,
      this.onScreenChangeCallbacks
    )

    fullPageParallax.init()
  }

  initModals = () => {
    modalNavigation.init(this.isMobile, PageName.MAIN, this.locale)
    modalInfrastructure.init(this.locale)
    modalAbouSlider.init()
    modalEventsSlider.init()
    modalFlats.init(this.locale)
    modalForm.init()
    modalVideo.init()
    modalTrezini.init()
    modalExclusives.init()
  };

  updatePanels = (index) => {
    const screen = ScreenName[index]

    this.updateHeader(screen)
    this.updateFooter(screen)
    this.updateLocales(screen)
    this.sendFbTarget(screen)
    this.toggleSidePanelsVisibility(screen)
  };

  updateLocales = (screen) => {
    const localesItems = this.locales.querySelectorAll(`.locales__item`)

    localesItems.forEach((item) => {
      const initialHref = item.getAttribute(`href`)
      const hashIndex = initialHref.indexOf(`#`)

      if (hashIndex === -1) {
        item.setAttribute(`href`, `${initialHref}#${screen}`)
      } else {
        const newHref = initialHref.slice(0, hashIndex)

        item.setAttribute(`href`, `${newHref}#${screen}`)
      }
    })
  };

  updateMobileFooter = (screen) => {
    const activeSlideAboutSlider = $(".about__slider .slick-active").attr(
      "data-slick-index"
    )

    if (screen !== mainScreenName.ABOUT) {
      $(this.aboutSlider).fadeOut()
    } else if (screen === mainScreenName.ABOUT) {
      $(this.aboutSlider).fadeIn()
    }
  };

  updateFooter = (screen) => {
    const {
      footer: { FOOTER_EXPANDED, PRESENTATION_MOVED, PRESENTATION_HIDDEN },
    } = classNames
    const toggle = this.footer.querySelector(`.page-footer__toggle`)
    const activeSlideAboutSlider = $(".about__slider .slick-active").attr(
      "data-slick-index"
    )

    this.footer.classList.toggle(
      FOOTER_EXPANDED,
      screen !== mainScreenName.INTRO && screen !== mainScreenName.PLACE
    )
    toggle.classList.toggle(
      classNames.footer.TOGGLE_SHOWN,
      screen === mainScreenName.PLACE
    )

    if (screen !== mainScreenName.INTRO) {
      $(this.copyright).fadeOut()
    } else {
      $(this.copyright).fadeIn()
    }

    if (screen !== mainScreenName.ABOUT) {
      $(this.aboutSlider).fadeOut()
    } else if (
      screen === mainScreenName.ABOUT &&
      activeSlideAboutSlider !== "0"
    ) {
      $(this.aboutSlider).fadeIn()
    }

    if (screen === mainScreenName.ABOUT) {
      this.presentation.classList.add(PRESENTATION_HIDDEN)
    }

    if (screen !== mainScreenName.INTRO && screen !== mainScreenName.PLACE) {
      setTimeout(() => {
        this.presentation.classList.add(PRESENTATION_MOVED)
      }, 700)

      return
    }

    if (this.presentation.classList.contains(PRESENTATION_MOVED)) {
      this.presentation.classList.add(PRESENTATION_HIDDEN)
      setTimeout(() => {
        this.presentation.classList.remove(PRESENTATION_MOVED)
        this.presentation.classList.remove(PRESENTATION_HIDDEN)
      }, 700)
    }
  };

  updateHeader = (screen) => {
    this.header.classList.toggle(
      classNames.header.HEADER_SHRINKED,
      screen !== mainScreenName.INTRO
    )
    this.menu.classList.remove(classNames.header.MENU_HIDDEN)
  };

  sendFbTarget = (screen) => {
    if (window.fbq !== undefined) {
      switch (screen) {
        case "intro":
          fbq("track", "Lead")
          break
        case "flats":
          fbq("track", "ViewContent")
          break
        case "contacts":
          fbq("track", "Contact")
          break
      }
    }
  };

  toggleSidePanelsVisibility = (screen) => {
    const sidePanels = [...this.page.querySelectorAll(`.side-panel`)]
    const arePanelsHidden = sidePanels.every((panel) =>
      panel.classList.contains(classNames.sidePanel.SIDE_PANEL_HIDDEN)
    )

    if (screen !== `about` && !arePanelsHidden) return

    sidePanels.forEach((panel) =>
      panel.classList.toggle(
        classNames.sidePanel.SIDE_PANEL_HIDDEN,
        screen === `about`
      )
    )
  };

  //infrastructure and flats mobile sliders
  toggleMobileDetailsLink(wrap, slideType, sliderType) {
    const details = wrap.querySelector(`.screen-pictures__details`)

    details.dataset.id = slideType

    if (sliderType === `flats`) {
      details.setAttribute(`href`, flatTypesAddresses[slideType])
    }
  }

  toggleMobileSliderTitles(wrap, slideType, sliderType) {
    const titles = [...wrap.querySelectorAll(`.${sliderType}__title`)]
    const activeSlideTitle = wrap.querySelector(
      `.${sliderType}__title[data-id="${slideType}"]`
    )

    const award = document.querySelector(".flats__award")

    if (sliderType === "flats") {
      if (slideType === "loft") {
        award.classList.add("visible")
      }
      if (slideType !== "loft") {
        award.classList.remove("visible")
      }
    }

    titles.forEach((title) =>
      title.classList.remove(classNames.mobile.SLIDER_TITLE_VISIBLE)
    )
    activeSlideTitle.classList.add(classNames.mobile.SLIDER_TITLE_VISIBLE)
  }

  formatValues() {
    const formatPhone = () => {
      const phones = this.page.querySelectorAll(`.js-phone`)
      const pattern = /\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{2})?[- ]?(\d{2})/g
      const subst = " ($1) $2 $3 $4"

      phones.forEach(
        (phone) => (phone.innerHTML = phone.innerHTML.replace(pattern, subst))
      )
    }

    formatPhone()
  }

  bind() {
    if (!this.isMobile) {
      this.setPicturesTogglesHandler()
    }
  }

  setPicturesTogglesHandler() {
    [...this.page.querySelectorAll(`.screen-pictures__control`)].forEach(
      (control) => {
        control.addEventListener(`mouseenter`, setGalleryToggler)
      }
    )
  }
}
